import axios from 'axios';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

interface Transaction {
  id: number;
  codigoFactura: string;
  cliente: string;
  fecha: string;
  total: number;
  tipoPago: string;
  estado: string;
  articulos: string[];
}

export class TransactionsServiceApi {
  private static baseURL = process.env.REACT_APP_API_URL || 'http://localhost:4020';
  private static cachedData: Transaction[] | null = null;
  private static lastFetch: Date | null = null;

  private static async fetchTransactions(): Promise<Transaction[]> {
    const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos
    const now = new Date();

    if (this.cachedData && this.lastFetch &&
      (now.getTime() - this.lastFetch.getTime()) < CACHE_DURATION) {
      return this.cachedData;
    }

    try {
      const ventasResponse = await axios.post(`${this.baseURL}/ventas/obtener-todas`);
      const ventas = ventasResponse.data;

      // Mapear y formatear las últimas 10 ventas
      const transactions: Transaction[] = ventas
        .map((venta: any) => ({
          id: venta.informacionVenta.id,
          codigoFactura: venta.informacionVenta.codigoFacturaVenta,
          cliente: venta.informacionVenta.nombreCliente,
          fecha: format(new Date(venta.informacionVenta.fechaVenta), 'dd MMMM yyyy', { locale: es }),
          total: venta.detalleVenta.total,
          tipoPago: venta.detalleVenta.tipoPago || 'No disponible',
          estado: this.mapEstado(venta.informacionVenta.estadoVenta),
          articulos: venta.articulosVendidos.map((art: any) => art.nombreArticulo)
        }))
        .slice(0, 10); // Obtener solo las últimas 10

      this.cachedData = transactions;
      this.lastFetch = now;

      return transactions;
    } catch (error) {
      console.error('Error fetching transactions:', error);
      return [];
    }
  }

  private static mapEstado(estadoId: number): string {
    switch (estadoId) {
      case 1: return 'Abierta';
      case 2: return 'Pendiente';
      case 3: return 'Anulada';
      case 4: return 'Finalizada';
      case 5: return 'Crédito';
      default: return 'Desconocido';
    }
  }

  static async getLatestTransactions(): Promise<Transaction[]> {
    try {
      return await this.fetchTransactions();
    } catch (error) {
      console.error('Error getting transactions:', error);
      return [];
    }
  }
}